var map = {
	"./ASHLUXE-PARADISE-INYONI-LOCATION0082_x950.png": 1326,
	"./M-LOCATION0057-1_x950.png": 2955,
	"./chris-ghinda-wK2ESlRRZQ8-unsplash.jpeg": 8559,
	"./jc-gellidon-JM8TkWJ9UIY-unsplash.jpeg": 5205,
	"./larm-rmah-R1Ku62Z7zqE-unsplash.jpeg": 8274,
	"./toa-heftiba-dti56waifB4-unsplash.jpeg": 9984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2594;